<template>
  <div>
    <v-style>
      .campaign-create .modal-body {
        height: {{modalHeight}};
        transition: height 0.2s;
        overflow-y: unset !important;
      }
    </v-style>
    <CModal :show.sync="activeDelete" centered :draggable="false">
      <template slot="header-wrapper">
        <div />
      </template>
      Etes-vous sûr de vouloir supprimer la campagne {{activeDeleteName}} ?
      <template slot="footer">
        <CButton color="secondary" class="mr-2" @click="activeDelete = null">
          Non
        </CButton>
        <CButton
          color="primary"
          @click="deleteCampaign"
          data-cy="confirm-delete-button"
        >
          Oui
        </CButton>
      </template>
    </CModal>
    <div class="d-flex justify-content-end mb-3">
      <CButton
        color="primary"
        @click="showCampaignCreationModal = true"
        data-cy="open-create-campaign-modal"
      >
        Nouvelle campagne
      </CButton>
    </div>
    <tableComponent
      :url="tableUrl"
      :columns="tableColumns"
      :headings="tableHeadings"
      :key="refreshTable"
      :filter-exclude-columns="['actions']"
      :sort-exclude-columns="['actions']"
      :show-top-number-of-records="false"
      :display-columns-selector="false"
      :not-formatted-columns="['nb_alumni']"
    >
      <template slot="name" slot-scope="{ row }">
        <CButton
          class="mr-2"
          variant="outline"
          color="primary"
          size="sm"
          :to="{ name: 'CampaignDetails', params: { campaign_id: row._id } }"
          data-cy="campaign-link"
        >
          {{ row.name }}
        </CButton>
      </template>
      <template slot="percentage_completed" slot-scope="{ row }">
        {{ row.percentage_completed }}%
      </template>
      <template slot="actions" slot-scope="{ row }">
        <div class="d-flex flex-wrap" style="row-gap: 0.25em; column-gap: 0.5em">
            <CButton
              class="sm outline action-button"
              color="primary"
              size="sm"
              variant="outline"
              :to="{ name: 'CampaignDetails', params: { campaign_id: row._id } }"
            >
                <em class="fa fa-edit"/>
                Modifier
            </CButton>
            <CButton
              class="sm outline action-button"
              color="primary"
              size="sm"
              variant="outline"
              @click="() => toggleCampaignStatus(row)"
              data-cy="open-close-button"
            >
              <em :class="row.status === 'ouvert' ? 'fa fa-lock' : 'fa fa-lock-open' "/>
              {{ row.status === "ouvert" ? "Fermer" : "Ouvrir" }}
            </CButton>
            <CButton
              class="sm outline action-button"
              color="primary"
              size="sm"
              variant="outline"
              @click="duplicateCampaign(row._id)"
            >
              <em class="fa fa-copy" />
              Duplicate
            </CButton>
            <CButton
              class="action-button"
              color="danger"
              size="sm"
              @click="activeDelete = row; activeDeleteName = row.name"
              data-cy="delete-button"
            >
              <em class="fa fa-close" />
              Supprimer
            </CButton>
        </div>
      </template>
    </tableComponent>
    <CModal
      class="campaign-create"
      centered
      :draggable="false"
      :resizable="false"
      :show.sync="showCampaignCreationModal"
    >
      <CInput
        class="mt-3 mb-4"
        label="Nom campagne"
        data-cy="new-campaign-name"
        v-model="newCampaignName"
      />
      <div data-cy="campaign-form-type">
        <MzSelect
          class="mb-4"
          searchable
          required
          label="Formulaire"
          :options="formTypeOptions"
          :value.sync="formType"
        />
      </div>
      <div data-cy="campaign-language">
        <MzSelect
          class="mb-5"
          searchable
          required
          label="Langue"
          @show="setModalHeight(400)"
          @hide="setModalHeight(315)"
          :options="formType === '2' ?  ['FR', 'EN'] : ['FR', 'EN', 'ZH']"
          :value.sync="campaignLanguage"
        />
      </div>
      <template slot="footer" slot-scope="{ row }">
        <CButton
          color="primary"
          @click="createCampaign"
          :disabled="!formType || !campaignLanguage"
          data-cy="create-campaign-button"
        >
          Créer la campagne
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import {CAMPAGNES_ENDPOINTS, CampaignService} from "@/services/campaign";
import {errorMessage} from "@/constants/common";
import {formTypeOptions} from "@/constants/common";

export default {
  name: "Campaigns",
  data() {
    return {
      formTypeOptions,
      modalHeight: 315,
      campaignLanguage: null,
      formType: null,
      activeDeleteName: null,
      refreshTable: 0,
      tableUrl: CAMPAGNES_ENDPOINTS.base,
      tableColumns: [
          "name",
          "status",
          "nb_alumni",
          "percentage_completed",
          { name: "creation_date", type: "date" },
          "actions"
      ],
      tableHeadings: {
        "name": "Nom campagne",
        "percentage_completed": "Progression %",
        "status": "Statut Campagne",
        "creation_date": "Date création",
      },
      activeDelete: null,
      showCampaignCreationModal: false,
      newCampaignName: "",
    }
  },
  watch: {
    formType(){
      if (this.formType == 2) this.campaignLanguage = 'FR'
    },
  },
  methods: {
    setModalHeight(height){
      this.modalHeight = `${height}px`
    },
    async toggleCampaignStatus(campaign) {
      const { res } = await CampaignService.updateCampaign(
          campaign._id,
          {status: campaign.status === "ouvert" ? "clos" : "ouvert"}
      );
      if (res.status !== 200) alert(errorMessage);
      this.refreshTable++
    },
    async deleteCampaign() {
      const { res } = await CampaignService.deleteCampaign(this.activeDelete._id);
      if (res.status !== 200) alert(errorMessage);
      this.activeDelete = null;
      this.refreshTable++;
    },
    async createCampaign() {
      const { res, data } = await CampaignService.createCampaign(
        {
          name: this.newCampaignName,
          form_id: this.formType,
          language: this.campaignLanguage
        }
      );
      if (res.status !== 201) alert(errorMessage);
      else await this.$router.push({
        name: "CampaignDetails",
        params: {campaign_id: data.id}
      })
    },
    async duplicateCampaign(id) {
      const { res } = await CampaignService.duplicateCampaign(id);
      if (res.status !== 200) alert(errorMessage);
      this.refreshTable++;
    },
  }
}
</script>

<style lang="scss">
.action-button {
  width: 7.5em;
}
</style>
